export default __webpack_public_path__ + "69ebc50617e7d61b513beaf94e4bdbb8.png";